goog.provide('el8.appshared.dialog.drugIntxnUnknownDetail');

goog.require('el8.uiwidget.NewDialog');
goog.require('el8.template.appshared.drugIntxns');
goog.require('el8.template.appshared.dialog.drugIntxnUnknownDetail');


el8.appshared.dialog.drugIntxnUnknownDetail = (function() {

    var that = new el8.uiwidget.NewDialog({
        title: "Decision Support Details",
        autoHeight: true,
        width: 500,
        modal: false,
        contentFn: el8.template.appshared.dialog.drugIntxnUnknownDetail.content,
        showXButton: true
    });

    var super_show = that.show;
    that.show = function(data) {
        super_show.call(that);
        if (data['type'] === 'drugDrug') {
            $('.drug-intxn-unknown-detail-content', that.getContentElt()).html(
                el8.template.appshared.drugIntxns.drugDrugUnknownDetail(data)
            );
        } else if (data['type'] === 'drugAllergy') {
            $('.drug-intxn-unknown-detail-content', that.getContentElt()).html(
                el8.template.appshared.drugIntxns.drugAllergyUnknownDetail(data)
            );
        }
        that.adjustHeight();
    };

    return that;

})();

